import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild} from "@angular/core";
import {Company} from "../../entities/company";
import {ModalComponent} from "../modal/modal.component";
import {CompanyService} from "../../services/company.service";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";
import {Router} from "@angular/router";

@Component({
    selector: 'app-company-form',
    templateUrl: './company-form.component.html'
})
export class CompanyFormComponent implements OnChanges {

    propertyFields = ["Activité Principale", "Code CDI",
        "Libellé CDI", "Localisation", "Régime Fiscal", "Ville"]

    @Input() company: Company;
    /** Emitted with the saved payee so the parent can refresh without a full page reload. */
    @Output() saved = new EventEmitter<Company>();
    @ViewChild('editForm', {static: true})
    public modal: ModalComponent

    /** Working copy edited in the dialog; discarded on Cancel, applied on Save. */
    model: Company;

    constructor(private companyService: CompanyService,
                private toastrService: ToastrService,
                private translate: TranslateService,
                private router: Router) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.company && !this.company['properties']) {
            this.company['properties'] = {}
        }
    }

    /** Tax ID and Name are required. */
    get isValid(): boolean {
        return !!(this.model && (this.model.tax_id || '').trim() && (this.model.company_name || '').trim());
    }

    show() {
        this.model = this.cloneCompany(this.company);
        this.modal.show()
    }

    cancel() {
        this.modal.hide()
    }

    hide() {
        this.modal.hide()
    }

    upsert() {
        if (!this.isValid) {
            return;
        }
        if (!this.model.id) {
            this.companyService.add$(this.model).subscribe(companyData => {
                this.toastrService.success(this.translate.instant('COMPANY.ADDED'));
                this.saved.emit(companyData);
                this.modal.hide();
                this.router.navigateByUrl(`/company/add-edit/${companyData.id}`);
            })
        } else {
            this.companyService.update$(this.model.id, this.model).subscribe(companyData => {
                this.toastrService.success(this.translate.instant('COMPANY.UPDATED'));
                this.saved.emit(companyData || this.model);
                this.modal.hide();
            })
        }
    }

    private cloneCompany(source: Company): Company {
        const clone: Company = source ? JSON.parse(JSON.stringify(source)) : new Company();
        if (!clone.properties) {
            clone.properties = {};
        }
        return clone;
    }

}
